export default __webpack_public_path__ + "static/media/photo-homme-poireau.4e7ad32e.png";